/***** This is the kind of object structure we want to have in the end *****
{ 
  audio: {
    "id": "e1c8e430-a181-461b-a620-11abf1bfb1e0", // block general information
    "name": "audio",                              // block general information
    "icon": "mdi-cast-audio",                     // block general information
    "title": "Audio",                             // block general information
    "description": "An audio",                    // block general information
    "category": "multimedia",                     // block general information
    "AIPanel": {},                                // block related component
    "Block": {},                                  // block related component
    "Panel": {},                                  // block related component
    "Toolbar": {},                                // block related component
    "block": {}                                   // block instance created by class
  },
  video: {.......}
}
*/

const blocksDefinitions = {};

function setBlocksGeneralInformation() {
	const context = require.context('./', true, /\.\/.*\/index\.js$/);

	context.keys().forEach(path => {
		const [, blockName] = path.split('/');
		blocksDefinitions[blockName] = context(path).default;
	});
}

function setBlocksRelatedComponents() {
	const contextComponents = require.context('./', true, /\.\/.*\/(Block|Toolbar|Panel|AIPanel)\.vue$/);
	contextComponents.keys().forEach(path => {
		const [, blockName, filename] = path.split('/');
		blocksDefinitions[blockName][filename.replace(/\..*$/, '')] = contextComponents(path).default;
	});
}

function setBlocksClassInstances() {
	const contextClass = require.context('./', true, /\.\/.*\/class.js$/);
	contextClass.keys().forEach(path => {
		const [, blockName, filename] = path.split('/');
		const BlockClass = contextClass(path).default;
		blocksDefinitions[blockName].block = new BlockClass();
		blocksDefinitions[blockName].class = BlockClass;
	});
}

setBlocksGeneralInformation();
setBlocksRelatedComponents();
setBlocksClassInstances();

export default blocksDefinitions;
